import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

// Dismissal is keyed to the announcement's row uuid, so posting a new one
// automatically reappears for everyone — no manual id discipline, which is
// what the previous code-constant version got wrong.
export const announcementDismissKey = (id) => `announcement_dismissed_${id}`;

export function useAnnouncement() {
  const [announcement, setAnnouncement] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    supabase.rpc('get_active_announcement').then(({ data, error }) => {
      if (cancelled) return;
      // A missing RPC (migration not yet run) must not break the feed — the
      // card simply doesn't render.
      if (error) console.error('get_active_announcement:', error);
      else setAnnouncement(data?.[0] ?? null);
      setLoading(false);
    });
    return () => { cancelled = true; };
  }, []);

  return { announcement, loading };
}
